module.exports = __webpack_public_path__ + "user.svg?b5b8f83d7015ec78c5720ff037ad7fcc";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/user.svg
// module id = 330
// module chunks = 2